import { render, staticRenderFns } from "./taskLoadingSummary.vue?vue&type=template&id=3613e1ae&scoped=true&"
import script from "./taskLoadingSummary.vue?vue&type=script&lang=js&"
export * from "./taskLoadingSummary.vue?vue&type=script&lang=js&"
import style0 from "./taskLoadingSummary.vue?vue&type=style&index=0&id=3613e1ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3613e1ae",
  null
  
)

export default component.exports